import { Kb3dModel } from '../decorators/kb3d-decorator';
import { eConnectorPositionMode } from '../enums';
import { ISketchControlPoint } from '../kb3d-models';
import { SketchPath } from '../meshes/sketch-node-path';
import { KbVector } from '../primitives';
import { Token } from '../token';
import { BaseConnector } from './base-connector';

@Kb3dModel({
    token: Token.SketchControlPoint,
})
export class SketchControlPoint extends BaseConnector implements ISketchControlPoint {
    enabled = true; // non-configurable
    positionMode = eConnectorPositionMode.absolute;
    direction2?: KbVector;

    /** override base parent for more specific typing*/
    public _parent: SketchPath | undefined;

    public getSketch() {
        return this._parent?._parent;
    }

    public getSpaceParent() {
        return this.getSketch();
    }

    public getAncestors() {
        return super.getAncestors() as SketchPath[];
    }
}

